module.exports = __webpack_public_path__ + "media/images/bag-a88b5f7cef94fb241cf866409b574525.jpeg";